import { iconFor, iconFromPirateKey } from '../lib/icons';
import type { DailyEntry } from '../types';

export default function DailyForecast({ days }: { days: DailyEntry[] }) {
  return (
    <section>
      <h2 className="text-xs uppercase tracking-wider opacity-70 mb-2">7-day</h2>
      <div className="space-y-1">
        {days.map((d) => {
          const Icon = iconFromPirateKey(d.iconKey) ?? iconFor(d.condition);
          const label = d.pirateSummary ?? d.condition;
          return (
            <div
              key={d.date}
              className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-lg p-3"
            >
              <div className="w-24 text-sm shrink-0">{d.name}</div>
              <Icon className="w-6 h-6 stroke-1 shrink-0" />
              <div className="flex-1 text-sm opacity-80 truncate">{label}</div>
              <div className="text-xs text-blue-200 shrink-0 w-10 text-right">
                {d.precipPct > 0 ? `${d.precipPct}%` : ''}
              </div>
              <div className="text-sm tabular-nums shrink-0 w-20 text-right">
                <span className="font-medium">{d.hi ?? '—'}°</span>
                <span className="opacity-60"> / {d.lo ?? '—'}°</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
